var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { CUSTOMER_FEEDBACK } from '../../constants/cmsResourceTypes';
import CustomerFeedback from './CustomerFeedback';
const CustomerFeedbackForm = (_a) => {
    var { onSubmit } = _a, props = __rest(_a, ["onSubmit"]);
    if (!onSubmit) {
        throw new Error('onSubmit is required for the form to submit the data somewhere!');
    }
    return React.createElement(CustomerFeedback, Object.assign({ submitCustomerFeedback: onSubmit }, props));
};
CustomerFeedbackForm.resourceType = CUSTOMER_FEEDBACK;
export default CustomerFeedbackForm;
//# sourceMappingURL=index.js.map